import { FullWidthSection } from '../FullWidthSection/FullWidthSection'
import PageContainer from '../PageContainer/PageContainer'

type BannerProps = {
  children?: React.ReactNode
  bgImgSrc?: string
  bgImgColor?: string
}

export const Banner = ({
  children,
  bgImgSrc,
  bgImgColor = 'lightblue',
}: BannerProps) => {
  return (
    <FullWidthSection className="flex flex-col relative z-0 min-h-[18rem] overflow-hidden">
      {bgImgSrc ? (
        <img
          src={bgImgSrc}
          alt=""
          className="absolute inset-0 h-full object-cover w-full"
        />
      ) : (
        <div
          className="absolute inset-0"
          style={{ backgroundColor: bgImgColor }}
        />
      )}
      <div className="relative h-full flex flex-col items-center justify-end">
        <PageContainer>
          <div className="mb-8">{children}</div>
        </PageContainer>
      </div>
    </FullWidthSection>
  )
}
